import React, { useCallback, useState } from 'react'
import VisibilitySensor from 'react-visibility-sensor'
import { listingType, sendImpression } from '../utils'
import OfferCard from '../OfferCard'
import OfferListItem from '../OfferListItem'

const Offer = ({
  offer,
  offerOrigin,
  offerType = 'card',
  revalidateList,
  beforeClaimAction,
  allowUnavailableActions = false,
  grayOutUnavailable = true,
  showUnavailableLabels = false,
}) => {
  const [impressionSent, setImpressionSent] = useState(false)

  const trackImpression = useCallback((isVisible) => {
    if (isVisible && !impressionSent && !offer.isPreview && offer.active) {
      setImpressionSent(true)
      sendImpression(offer.id, offerOrigin) // sending impression
      console.log('Impression sent for offer:', offer.id)
    }
  }, [offer.active, offer.id, impressionSent, offer.isPreview, offerOrigin])
  return (
    <VisibilitySensor onChange={trackImpression} partialVisibility={true}>
      {
        offerType === listingType.card ?
        <OfferCard
          {...offer}
          allowUnavailableActions={allowUnavailableActions}
          grayOutUnavailable={grayOutUnavailable}
          showUnavailableLabels={showUnavailableLabels}
          revalidateList={revalidateList}
          beforeClaimAction={beforeClaimAction}
        />
        :
        <OfferListItem
          offer={offer}
          allowUnavailableActions={allowUnavailableActions}
          grayOutUnavailable={grayOutUnavailable}
          showUnavailableLabels={showUnavailableLabels}
          revalidateList={revalidateList}
          beforeClaimAction={beforeClaimAction}
        />
      }
    </VisibilitySensor>
  )
}

export default Offer
